import initIndustryInsights from "./IndustryInsights";
import initTourismEvents from "./TourismEvents";
import initIndustryEvents from "./IndustryEvents";
import initNewsArticles from "./NewsArticles";
import initSearchPage from "./SearchPage";
import initSearchModal from "./SearchModal";
import initChatBot from "./ChatBot";
import initComments from "./Comments";

export default function initComponents() {
  initSearchModal();
  initSearchPage();
  initIndustryInsights();
  initTourismEvents();
  initIndustryEvents();
  initNewsArticles();
  initChatBot();
  initComments();
}
